// extracted by mini-css-extract-plugin
module.exports = {"promises-poster":"Promises_promises-poster_2RzJH","promises-poster-highlighted-words":"Promises_promises-poster-highlighted-words_dBKhz"};